module.exports = __webpack_public_path__ + "img/bluemotor-logo.3bc606ec.png";